import Swiper from 'swiper'
import { A11y, Navigation } from 'swiper/modules'

document.querySelectorAll('.element-photogalleryslider').forEach((el) => {
  const container = el.querySelector('.swiper')
  const numSlides = el.querySelectorAll('.swiper-slide').length

  new Swiper(container, {
    modules: [A11y, Navigation],
    slidesPerView: 2,
    spaceBetween: 24,
    speed: 500,
    navigation: {
      nextEl: el.querySelector('.slider-button-next'),
      prevEl: el.querySelector('.slider-button-prev'),
    },
    centeredSlides: numSlides < 2,
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: 5,
        spaceBetween: 30,
      },
    },
  })
})
